<template>
  <main class="home-page">
    <slot />
  </main>
</template>

<script>
export default {
  name: "HomePageShell",
};
</script>
